import React, {Component} from 'react';
import {translate} from 'react-i18next';
import config from '../../config/config.js';
import axios from 'axios';

import {NotificationManager} from 'react-notifications';

import PageHeader from '../elements/PageHeader';
import TranslationContainer from '../../containers/elements/translation/TranslationContainer';
import AddEditDialogContainer from '../../containers/elements/translation/AddEditDialogContainer';

class TranslationScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isCsvUploading: false
        };

        this.handleSearchStringChange = this.handleSearchStringChange.bind(this);
        this.handleAddTranslation = this.handleAddTranslation.bind(this);
        this.handleCsvUpload = this.handleCsvUpload.bind(this);
    }

    componentDidMount() {
        this.props.getTranslations(true);
    }

    handleSearchStringChange(e) {
        this.props.filterTranslationsBySearchString(e.target.value);
    }

    handleAddTranslation() {
        this.props.openDialogAddTranslation();
    }

    handleCsvUpload(e) {
        let data = e.target.files;
        if (e.target.files[0] != null) {
            this.setState({
                isCsvUploading: true
            });
            let formData = new FormData();
            formData.append('file', data[0]);
            axios.post(config.server.endpoint + 'backend/translation/csv', formData, {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }).then(response => {
                this.setState({
                    isCsvUploading: false
                });
                NotificationManager.success('Translations successfully imported.', 'Import done', 10000);
                this.props.getTranslations(true);
            }).catch(error => {
                this.setState({
                    isCsvUploading: false
                });
                NotificationManager.error('An error occured while importing csv file', 'Import error', 10000);
            });
        }
    }

    render() {
        const {t} = this.props;
        return (
            <div className="TranslationScreen">
                <PageHeader title={t('translation.title')}/>
                <div className="wrapper wrapper-content">
                    <div className="translations-container">
                        <div className="buttons text-right m-b">
                            <div className="btn-group">
                                <button className="btn btn-primary"
                                        onClick={this.handleAddTranslation}>
                                    <i className='fa fa-plus inline-block m-r-sm'/>
                                    {t('translation.buttons.addTranslation')}
                                </button>
                                <button className="btn btn-warning"
                                        disabled={this.state.isCsvUploading}
                                        onClick={() => this.csvUpload.click() }>
                                    <i className={"fa inline-block m-r-sm" + (this.state.isCsvUploading ? ' fa-spin fa-spinner' : ' fa-file-excel-o')}/>
                                    {t('translation.buttons.csvImport')}
                                </button>
                                <input type="file" ref={(ref) => this.csvUpload = ref} style={{ display: 'none' }} accept=".csv" onChange={this.handleCsvUpload}/>
                            </div>
                        </div>
                        <input type="text" name="searchString" onChange={this.handleSearchStringChange}
                               className="form-control form-control-lg block m-b"
                               placeholder={t('translation.search.placeholder')} value={this.props.searchString}/>
                        {this.props.translations instanceof Array ? this.props.translations.map((translation, i) => (
                            translation.visible ? (
                                <TranslationContainer translation={translation} key={i}/>
                            ) : null
                        )) : null}
                    </div>
                </div>
                {this.props.addEditDialog && this.props.addEditDialog.open ? (
                    <AddEditDialogContainer/>
                ) : null}
            </div>
        )
    }
}

export default translate()(TranslationScreen);